// context/reducer.js
import {
    SET_MENUS,
    SET_USER_CHOICES,
    SET_MAIN_CATEGORY_ID,
    SET_MAIN_CATEGORY_NAME,
    SET_ACTIVE_MENU,
    SET_ACTIVE_SUB_MENU,
    SET_SUB_CATEGORY_ID,
    SET_ITEM_CHOICES,
    SET_CHOSEN_CATEGORY,
    SET_FILTERED_ITEMS,
    SET_TOTAL_MONTH_PRICE,
    SET_ORDER,
  } from './actionTypes';
  
  export const reducer = (state, action) => {
    switch (action.type) {
      case SET_MENUS:
        return { ...state, menus: action.payload };
      case SET_TOTAL_MONTH_PRICE:
        return { ...state, totalMonthPrice: action.payload };
      case SET_ORDER:
        return { ...state, userOrder: action.payload };
      case SET_USER_CHOICES:
        return { ...state, userChoices: action.payload };
      case SET_MAIN_CATEGORY_ID:
        return { ...state, mainCategoryID: action.payload };
      case SET_MAIN_CATEGORY_NAME:
        return { ...state, mainCategoryName: action.payload };
      case SET_ACTIVE_MENU:
        return { ...state, activeMenu: action.payload };
      case SET_ACTIVE_SUB_MENU:
        return { ...state, activeMenusubCategory: action.payload }; // Corrected case
      case SET_SUB_CATEGORY_ID:
        return { ...state, subCategoryID: action.payload };
      case SET_ITEM_CHOICES:
        return { ...state, itemChoices: action.payload };
      case SET_CHOSEN_CATEGORY:
        return { ...state, chosenCategory: action.payload };
      case SET_FILTERED_ITEMS:
        return { ...state, filteredItems: action.payload };
      default:
        return state;
    }
  };
  